const FAILURE_CODE_LABELS: Record<string, string> = {
  CONFIG_NOT_FOUND: 'Config not found',
  CONFIG_DISABLED: 'Config disabled',
  CONFIG_INCOMPLETE: 'Config incomplete',
  EMPTY_CHANNEL_SITE_URL: 'Empty channel site URL',
  CHANNEL_LOCKED: 'Channel locked',
  CHANNEL_LOCK_EXTEND_FAILED: 'Channel lock extend failed',
  PRODUCT_NOT_FOUND: 'Product not found',
  INVALID_DELTA_SINCE: 'Invalid delta date',
  RUNTIME_ERROR: 'Runtime error',
};

const formatErrorKey = (key: string) => {
  return key
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());
};

export const formatMerchantErrorSummary = (
  failureCode?: string | null,
  errorSummary?: Record<string, unknown> | null,
) => {
  const lines: string[] = [];

  if (failureCode) {
    lines.push(`Failure: ${FAILURE_CODE_LABELS[failureCode] ?? failureCode}`);
  }

  if (errorSummary && typeof errorSummary === 'object') {
    Object.entries(errorSummary).forEach(([key, value]) => {
      if (!value) return;
      lines.push(`${formatErrorKey(key)}: ${value}`);
    });
  }

  const short = lines[0] ?? '-';

  return {
    shortText: short,
    fullText: lines.length > 1 ? lines.join('\n') : short,
  };
};
